import { render } from "./KryptonPopinHeader.vue?vue&type=template&id=5c66cc32&lang=pug"
import script from "./KryptonPopinHeader.vue?vue&type=script&lang=js"
export * from "./KryptonPopinHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__